import React from "react";
import EmailPage from "../components/EmailManagement/EmailPage";
import SendUpload from "../components/EmailManagement/SendUpload";

// Email role: send a template to the candidates in an uploaded file (SMS / WhatsApp / Email)
export default function SendUploadPage() {
  return (
    <EmailPage title="Send by Upload" crumbs={[{ label: "Send by Upload" }]}>
      <SendUpload />
    </EmailPage>
  );
}
